import { Dispatch as ReactDispatch, SetStateAction } from "react";
import { openLiveChat } from "@tvg/utils/liveChatUtils";
import formatCurrency from "@tvg/formatter/currency";
import { replaceCAPIVariables } from "@tvg/utils/capiUtils";
import { ErrorMessage } from "../../../../types";
import { WithdrawalWarningMessages } from "../types";

export const handleWithdrawRetry =
  (
    errorMessage: ErrorMessage,
    setErrorMessage: ReactDispatch<SetStateAction<ErrorMessage>>
  ) =>
  () => {
    if (errorMessage.retryCount <= 2) {
      setErrorMessage((prevState) => ({
        ...prevState,
        retryCount: prevState.retryCount + 1,
        isOpen: false,
        isRetry: true
      }));
    } else {
      // Contact Customer Service
      openLiveChat();
    }
  };

export const handleWithdrawCloseError =
  (setErrorMessage: ReactDispatch<SetStateAction<ErrorMessage>>) => () => {
    setErrorMessage((prevState) => ({
      ...prevState,
      isOpen: false,
      isRetry: false
    }));
  };

const defaultWarningMessages: WithdrawalWarningMessages = {
  warningMinLimit: "~amount~ MINIMUM WITHDRAWAL",
  warningMaxLimit: "~amount~ MAXIMUM WITHDRAWAL",
  insufficientFunds: "Insufficient funds(~amount~)"
};

export const insufficientFundsErrorMessage = ({
  minWithdrawAmount,
  userBalance,
  value,
  capiMaxWithdrawAmount,
  warningMessages = defaultWarningMessages
}: {
  minWithdrawAmount: string;
  userBalance: number;
  value: string;
  capiMaxWithdrawAmount?: number;
  warningMessages?: WithdrawalWarningMessages;
}) => {
  if (+value < +minWithdrawAmount) {
    return replaceCAPIVariables(warningMessages.warningMinLimit, {
      amount: formatCurrency(+minWithdrawAmount)
    });
  }
  if (capiMaxWithdrawAmount !== undefined && +value > capiMaxWithdrawAmount) {
    return replaceCAPIVariables(warningMessages.warningMaxLimit, {
      amount: formatCurrency(capiMaxWithdrawAmount)
    });
  }
  return replaceCAPIVariables(warningMessages.insufficientFunds, {
    amount: formatCurrency(userBalance)
  });
};
